/**
 * External dependencies
 */
import { __ } from '@wordpress/i18n';

export const numberWords = [
	__( 'any', 'woocommerce-payments' ),
	__( 'one', 'woocommerce-payments' ),
	__( 'two', 'woocommerce-payments' ),
	__( 'three', 'woocommerce-payments' ),
	__( 'four', 'woocommerce-payments' ),
	__( 'five', 'woocommerce-payments' ),
	__( 'six', 'woocommerce-payments' ),
	__( 'seven', 'woocommerce-payments' ),
	__( 'eight', 'woocommerce-payments' ),
	__( 'nine', 'woocommerce-payments' ),
];

export const recommendedCurrencyCodes = [
	'USD',
	'EUR',
	'JPY',
	'GBP',
	'AUD',
	'CAD',
	'INR',
];
